import { types } from 'mobx-state-tree';

const Alert = types.model('Alert', {
  type: types.maybeNull(types.enumeration(['SUCCESS', 'ERROR'])),
  text: types.maybeNull(types.string),
  duration: types.maybeNull(types.number)
}).actions((self) => {
  return {
    showAlert(options) {
      Object.assign(self, options);
    },

    hideAlert() {
      self.type = null;
      self.text = null;
      self.duration = null;
    }
  }
})

export default Alert;
